(function (angular) {
  "use strict";

  angular.module('myApp').component('downloadInquiryUs', {
    templateUrl: '/downloadInquiryUs/downloadInquiryUs.tpl.html',
    controller: [
      '$scope', '$http', 'aimSave', 'exportInquiryService',
      function ($scope, $http, aimSave, exportInquiryService) {

        $scope.aim = new aimSave();
        $scope.aim.serviceMethod = exportInquiryService.save;
        $scope.aim.dto.country = "United States";

        // Select 2 Script
        setTimeout(function () {
          // select2
          $('.custom-selectbox').select2({
            minimumResultsForSearch: -1,
          });
        }, 200);

        exportInquiryService.categories().then(function (resp) {
          $scope.categories = resp.data;
        });

        $scope.productChange = function () {
          if ($scope.aim.dto.categoryId != null && $scope.aim.dto.categoryId != undefined) {
            exportInquiryService.products($scope.aim.dto.categoryId).then(function (resp) {
              $scope.products = resp.data;
            });
          }
          else {
            $scope.products = {};
          }
        }
      }
    ],
  });

}(window.angular));
